export const environment = {
  production: true,
  appVersion: require('../../package.json').version + '-devstage', // eslint-disable-line
  appName: require('../../package.json').name, // eslint-disable-line
  appPrefix: 'marketplacebilling',
  stage: 'dev',

  marketplaceBillingBackendUrl:
    'https://essp-api-bemarketplacebilling-dev.acp-gruppe.com',
  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: '3f5bfc78-00f0-44b6-ac00-22eaec817b0e',
  scope: 'openid profile roles groups acpprofile offline_access',
};